module.exports = __webpack_public_path__ + "img/zoom-in.48ae9c10.svg";